module.exports = __webpack_public_path__ + "img/docImmigration.7f8d88eb.svg";